import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuthGuard } from "src/hooks/useAuthGuard";
import Loader from "src/components/common/Loader";
import Button from "src/components/dashboard/Button";
import { sendMessageToParent } from "src/helpers/common";
import { POST_MESSAGE_EVENTS } from "src/constants/common";

const AuthPage: React.FC = () => {
  const navigate = useNavigate();
  const { status, redirectTo } = useAuthGuard();

  useEffect(() => {
    if (redirectTo && status === "success") {
      navigate(redirectTo, { replace: true });
    }
  }, [redirectTo, status, navigate]);

  if (status === "error") {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-red-500 text-xl font-semibold">
        <div>Something went wrong!</div>
        <Button
          onClick={() => sendMessageToParent(POST_MESSAGE_EVENTS.FORCE_LOGOUT)}
        >
          Logout and Re-Login.
        </Button>
      </div>
    );
  }

  if (status === "invalid-program") {
    return (
      <Navigate
        to="/programs/goodflip-care-program/onboarding/existing-user"
        replace
      />
    );
  }

  return (
    <div className="flex justify-center items-center h-screen">
      <Loader size="lg" />
    </div>
  );
};

export default AuthPage;
